import React from 'react'
import {
  GelForm,
  GelFormField,
  useGelFormData,
  GelTextInput,
  GelButton,
  GelBoxLayout,
  GelEmailInput
} from '@tal-gel/components'
import styled from '@emotion/styled'
import axios from 'axios'

import { testUrl } from '../../../data/urls'

const StretchWrapper = styled.div`
  & > div > div {
    flex-grow: 1;
  }
`

const EmailForm = ({ id, onConfirmation, voucher }) => {
  const { formData, onFormDataChange, onFormDataReset, resetForm } =
    useGelFormData({
      firstName: '',
      lastName: '',
      email: ''
    })

  const onSubmit = async () => {
    const { firstName, lastName, email } = formData
    try {
      await axios.put(`${testUrl}/surveys/${id}`, {
        email,
        firstName,
        lastName
      })
      onConfirmation()
    } catch (error) {
      console.log(error)
    }
  }

  // const onResponse = (response) => {
  //   console.log('response', response)
  // }

  const onError = (error) => {
    console.error('error', error)
  }

  return (
    <GelForm
      labelAtTop
      disableOnSubmit
      preventSubmitOnInvalid
      onSubmit={onSubmit}
      reset={resetForm}
      onReset={onFormDataReset}
      // parseResponseBody={false} // Remove this if you use `fetch` in `onSubmit`
      // onResponse={onResponse}
      onError={onError}
    >
      <StretchWrapper>
        <GelBoxLayout
          space='auto'
          distribution='start'
          style={{ marginBottom: '12px' }}
        >
          <GelFormField
            label='First Name'
            tooltip=''
            style={{ marginBottom: '12px' }}
          >
            <GelTextInput
              name='firstName'
              value={formData.firstName}
              onChange={onFormDataChange}
              required
              regex={/^[a-z ,.'-\s]+$/i}
              errorMsg={{
                required: 'First name is required',
                regex: 'Invalid character'
              }}
            />
          </GelFormField>
          <GelFormField
            label='Last Name'
            tooltip=''
            style={{ marginBottom: '12px' }}
          >
            <GelTextInput
              name='lastName'
              value={formData.lastName}
              onChange={onFormDataChange}
              required
              regex={/^[a-z ,.'-\s]+$/i}
              errorMsg={{
                required: 'Last name is required',
                regex: 'Invalid character'
              }}
            />
          </GelFormField>
        </GelBoxLayout>
      </StretchWrapper>

      {/* TODO check if it can be used without "-" */}
      <GelFormField label='Email' tooltip='' style={{ marginTop: '-12px' }}>
        <GelEmailInput
          name='email'
          value={formData.email}
          onChange={onFormDataChange}
          required
          errorMsg={{
            required: 'Email is required',
            format: 'Invalid format'
          }}
        />
      </GelFormField>

      <GelBoxLayout space='auto' distribution='start'>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            primary
            large
            iconRight={voucher ? 'Heart' : 'Email'}
            submit
          >
            {voucher ? 'Redeem' : 'Submit'}
          </GelButton>
        </GelFormField>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            secondary
            large
            onClick={onFormDataReset}
          >
            Reset
          </GelButton>
        </GelFormField>
      </GelBoxLayout>
    </GelForm>
  )
}

export default EmailForm
